import { render, staticRenderFns } from "./ques-checkbox.vue?vue&type=template&id=33f1e080&scoped=true&"
import script from "./ques-checkbox.vue?vue&type=script&lang=js&"
export * from "./ques-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ques-checkbox.vue?vue&type=style&index=0&id=33f1e080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f1e080",
  null
  
)

export default component.exports